export default {
  brand: 'Sun Power',
  studio: 'Studio',
  lottery: 'Tirage',
  companyHome: 'Entreprise',
  companyHomeNotConfigured: 'Site entreprise non configuré',
  game: 'Jeux',
  profile: 'Profil',
  service: 'Support',
  serviceNotConfigured: 'Lien support non configuré',
  language: 'Langue',
  login: 'Connexion',
  register: "S'inscrire",
  email: 'E-mail',
  password: 'Mot de passe',
  inviteCode: 'UID',
  uid: 'UID',
  shareLink: 'Lien de partage',
  copyLink: 'Copier le lien',
  copied: 'Copié',
  copyFail: 'Échec de la copie',
  recharge: 'Recharger',
  withdraw: 'Retirer',
  exchange: 'Échanger',
  balanceUsd: 'Solde USD',
  balanceKwh: 'Énergie kWh',
  checkin: 'Check-in',
  upgrade: 'Niveau',
  team: 'Mon équipe',
  basic: 'Basique',
  vip1: 'VIP1',
  vip2: 'VIP2',
  vip3: 'VIP3',
  activity: 'Promo',
  unitPrice: 'Prix unitaire',
  quantity: 'Quantité',
  minQtyTip: 'Commande min. : {n}',
  expectKwh: 'Énergie prévue',
  totalAmount: 'Montant total',
  progress: 'Progression',
  buy: 'Acheter',
  buyConfirm: 'Confirmer l’achat',
  confirmBuy: 'Payer',
  buyConfirmTip: 'Le montant sera débité de votre solde USD. Irréversible.',
  buySuccess: 'Achat réussi',
  productName: 'Produit',
  amount: 'Montant',
  rechargeRate: 'Taux de change',
  rechargeActual: 'Montant crédité',
  enterAmount: 'Saisir le montant',
  network: 'Réseau',
  selectNetwork: 'Choisir le réseau',
  withdrawAddress: 'Adresse',
  enterWithdrawAddress: "Saisir l'adresse",
  txHash: 'Hash Tx',
  txHashOptional: 'Optionnel après transfert',
  copyAddress: "Copier l'adresse",
  rechargeHint: "Envoyez l'USDT à l'adresse ; le solde sera crédité sous peu après envoi",
  withdrawHint: 'Solde bloqué à la demande ; frais déduits, puis paiement après validation',
  withdrawFeeRate: 'Taux de frais',
  withdrawFee: 'Frais',
  withdrawReceive: 'Vous recevez',
  withdrawTooLow: 'Montant trop bas après frais',
  rechargeSubmitted: 'Recharge soumise',
  withdrawSubmitted: 'Retrait soumis',
  noQr: 'Pas de QR',
  noRechargeAddress: 'Adresse non configurée',
  rechargeProof: 'Preuve de paiement',
  rechargeProofTip: 'Téléversez la capture du transfert réussi',
  rechargeProofRequired: 'Veuillez téléverser la preuve',
  confirm: 'Confirmer',
  cancel: 'Annuler',
  kyc: 'KYC',
  realName: 'Nom réel',
  idCard: "N° d'identité",
  contact: 'Contact',
  contactPlaceholder: 'Téléphone / WhatsApp / Telegram',
  contactRequired: 'Contact requis',
  idFront: 'Recto du document',
  idBack: 'Verso du document',
  kycStatus: 'Statut KYC',
  kycNone: 'Non vérifié',
  kycPending: 'En cours',
  kycApproved: 'Vérifié',
  kycRejected: 'Non approuvé',
  kycTip: "Renseignez vos infos et téléversez les deux faces du document",
  kycRequired: 'Nom et pièce d’identité requis',
  kycNeedPhotos: 'Veuillez téléverser les photos',
  kycSubmitted: 'Soumis, veuillez patienter',
  submit: 'Soumettre',
  logout: 'Déconnexion',
  appDownload: 'Télécharger l\'App',
  downloadPickTip: 'Choisissez le système de votre téléphone, puis suivez le guide d\'installation',
  downloadAndroidShort: 'Fichier APK (Android)',
  downloadIosShort: 'Profil de configuration (iPhone / iPad)',
  downloadNow: 'Télécharger maintenant',
  downloadAndroidSteps: [
    'Appuyez sur le bouton ci-dessous pour télécharger l\'APK',
    'Ouvrez Fichiers / Téléchargements, trouvez le fichier Sun Power et ouvrez-le',
    'Si Google Play Protect affiche « Appli bloquée » : appuyez sur « Installer quand même »',
    'Si l\'installation d\'apps inconnues est bloquée : Paramètres → Applications → Accès spécial → Installer des apps inconnues, autorisez le navigateur ou le gestionnaire de fichiers',
    'Suivez les instructions à l\'écran pour installer, puis ouvrez Sun Power'
  ],
  downloadIosSteps: [
    'Appuyez sur le bouton ci-dessous ; Safari ouvrira le profil d\'installation',
    'Si vous voyez « Profil téléchargé » : ouvrez Réglages → Profil téléchargé (ou Général → VPN et gestion de l\'appareil)',
    'Appuyez sur Installer, saisissez votre code, puis confirmez',
    'Après l\'installation, ouvrez Sun Power depuis l\'écran d\'accueil',
    'Si l\'app ne s\'ouvre pas : Réglages → Général → VPN et gestion de l\'appareil → sélectionnez le profil → Faire confiance'
  ],
  downloadAndroidNote: 'Cette appli est téléchargée depuis notre site, pas depuis Google Play. L\'alerte Play Protect est normale — choisissez « Installer quand même ».',
  downloadIosNote: 'Utilisez Safari pour l\'installation. Les autres navigateurs peuvent ne pas installer correctement le profil.',
  downloadStarting: 'Préparation du téléchargement…',
  downloadStarted: 'Téléchargement démarré. Vérifiez le navigateur ou les notifications',
  downloadIosStarted: 'Ouverture du profil d\'installation. Suivez les instructions',
  downloadFail: 'Échec du téléchargement. Réessayez',
  downloadUnavailable: 'Package indisponible. Contactez le support',
  legalLicense: 'Licence légale',
  businessReward: 'Activité et récompenses',
  companyNews: 'Actualités',
  newsEmpty: 'Aucune actualité',
  newsAttachment: 'Voir la pièce jointe',
  loading: 'Chargement…',
  attachmentLoadFail: 'Échec du chargement de la pièce jointe. Réessayez plus tard.',
  vipLevelNotify: 'Niveau VIP',
  vipLevelChanged: 'Votre niveau VIP est passé de {from} à {to}',
  gotIt: 'Compris',
  loginNotice: 'Avis',
  roulette: 'Roulette russe',
  prizes: 'Prix',
  lotteryRules: 'Règles du tirage',
  draw: 'Tirer',
  lotteryTimes: 'Chances',
  lotteryWin: 'Vous avez gagné',
  lotteryThanks: 'Merci de participer',
  lotteryThanksShort: 'Merci',
  lotteryThanksTip: 'Pas de prix cette fois — réessayez',
  lotteryRewardTip: '{reward} a été crédité sur votre compte',
  lotteryTimesReward: 'Vous avez obtenu {n} chance(s)',
  lotteryNoChance: 'Plus de chances',
  catchSun: 'Attrape soleil',
  startGame: 'Démarrer',
  score: 'Score',
  timeLeft: 'Temps restant',
  gameOver: 'Fin de partie',
  reward: 'Récompense',
  timesLeft: 'Parties restantes',
  gameNoChance: 'Plus de parties aujourd’hui',
  announcement: 'Annonce',
  noData: 'Aucune donnée',
  loginTip: 'Connexion par e-mail',
  registerTip: 'Inscription avec UID',
  emailPlaceholder: 'Votre e-mail',
  passwordPlaceholder: 'Votre mot de passe',
  confirmPassword: 'Confirmer',
  confirmPasswordPlaceholder: 'Répétez le mot de passe',
  invitePlaceholder: 'Saisir le UID',
  emailRequired: 'E-mail requis',
  passwordRequired: 'Mot de passe requis',
  passwordMin: '6 caractères minimum',
  confirmPasswordRequired: 'Confirmation requise',
  passwordMismatch: 'Mots de passe différents',
  inviteRequired: 'UID requis',
  noAccount: 'Pas encore de compte ?',
  hasAccount: 'Déjà un compte ?',
  registerSuccess: 'Inscription réussie',
  show: 'Voir',
  hide: 'Cacher',
  back: 'Retour',
  level: 'Niveau',
  checkinDays: 'Jours consécutifs',
  checkinTip: '{days} jours consécutifs = 1 chance de tirage',
  doCheckin: 'Check-in',
  alreadyCheckin: 'Déjà fait aujourd\'hui',
  checkinSuccess: 'Check-in réussi',
  checkinLottery: 'Check-in réussi + 1 tirage',
  upgradeTip: 'VIP1 nécessite toutes les conditions',
  kycDone: 'KYC fait',
  firstRecharge: '1er dépôt',
  inviteKyc: 'Invités KYC',
  inviteRecharge: 'Invité a rechargé',
  teamCount: 'Invités directs',
  teamL1: 'Niveau 1',
  teamL2: 'Niveau 2',
  teamL3: 'Niveau 3',
  teamAll: 'Tous',
  teamInviter: 'Invité par',
  teamInviterNone: 'Aucun parrain (inscription sans invitation membre)',
  teamDownline: 'Mes invités',
  teamUpL1: 'Parrain N1',
  teamUpL2: 'Parrain N2',
  teamUpL3: 'Parrain N3',
  teamUpRel1: 'Qui vous a invité directement',
  teamUpRel2: 'Qui a invité votre parrain',
  teamUpRel3: 'Parrain deux niveaux au-dessus',
  teamParentSelf: 'Invitation directe (par vous)',
  teamParentL1: 'Parrain N1',
  teamParentL2: 'Parrain N2',
  teamRefByL1: 'Invité par N1 {email}',
  teamRefByL2: 'Invité par N2 {email}',
  teamRefL1: 'Sous N1 {email}',
  logs: 'Historique',
  myOrders: 'Mes commandes',
  dailyRebate: 'Dividendes journaliers',
  rebateToday: "Aujourd'hui",
  rebateTotal: 'Total',
  rebateTip: 'La remise quotidienne convertit le kWh réservé en solde USD (retrait). Activez la tâche planifiée pour générer des enregistrements.',
  totalKwh: 'kWh total',
  pendingKwh: 'En attente',
  releasedKwh: 'Libéré',
  orderStatus: {
    '0': 'En cours',
    '1': 'Terminé',
    '2': 'Fermé'
  },
  exchangeTip: 'Convertir le kWh stocké en solde USD',
  exchangeAvailable: 'Disponible',
  exchangeRate: 'Taux',
  exchangeFee: 'Frais',
  exchangeAmountKwh: 'Quantité (kWh)',
  exchangeAll: 'Tout',
  exchangeReceive: 'Vous recevez',
  exchangeExceed: 'Dépasse le kWh disponible',
  exchangeNoKwh: 'Aucun kWh à échanger',
  success: 'Succès',
  playing: 'En jeu',
  tapSun: 'Touchez le soleil qui tombe',
  accountType: {
    USD: 'USD',
    KWH: 'kWh'
  },
  logType: {
    RECHARGE: 'Recharge',
    WITHDRAW: 'Retrait',
    WITHDRAW_REFUND: 'Remboursement retrait',
    EXCHANGE: 'Échange',
    GAME: 'Récompense jeu',
    LOTTERY: 'Loterie',
    INVITE_KYC: 'Bonus invitation KYC',
    BUY_PRODUCT: 'Achat produit',
    REBATE_Ln: 'Commission N{n}',
    REBATE_L1: 'Commission N1',
    REBATE_L2: 'Commission N2',
    REBATE_L3: 'Commission N3',
    DAILY_REBATE: 'Retour quotidien',
    MANAGE_REWARD: 'Prime de gestion',
    ADMIN_ADJUST: 'Ajustement admin'
  }
}
